// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1aor1","infoBtn":"quickbooks_infoBtn__2pmnN","formBox":"quickbooks_formBox__3p4Gz","formFooter":"quickbooks_formFooter__3vsyy"};